module.exports = __webpack_public_path__ + "static/media/visual-produce-icon.0d68181e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/visual-produce-icon.png
// module id = 1106
// module chunks = 0